import { cn } from "@/lib/utils";
import { STATUS, PRIORITY, lateness } from "@/lib/format";
import { AlertTriangle } from "lucide-react";

const base = "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap";

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid} className={cn(base, STATUS[status]?.cls)}>{STATUS[status]?.label || status}</span>
);

export const PriorityBadge = ({ priority }) => (
  <span className={cn(base, PRIORITY[priority]?.cls)}>{PRIORITY[priority]?.label || priority}</span>
);

export const OverdueBadge = ({ order, testid }) =>
  order.is_overdue ? (
    <span data-testid={testid} className={cn(base, "bg-red-600 text-white border-red-600")}>
      <AlertTriangle className="h-3 w-3" /> {lateness(order.due_current)}
    </span>
  ) : null;

export const DemoBadge = ({ show }) =>
  show ? <span className={cn(base, "bg-zinc-900 text-white border-zinc-900 text-[10px] tracking-wider")}>DEMO</span> : null;

const DOT = { red: "bg-red-500", yellow: "bg-amber-400", green: "bg-emerald-500", neutral: "bg-zinc-300", grey: "bg-zinc-300" };
export const Semaphore = ({ color, className }) => (
  <span className={cn("inline-block h-2.5 w-2.5 rounded-full ring-4", DOT[color], color === "red" ? "ring-red-500/15" : color === "yellow" ? "ring-amber-400/20" : "ring-emerald-500/15", className)} />
);

export const NativeSelect = ({ value, onChange, children, className, testid, ...rest }) => (
  <select
    data-testid={testid}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    className={cn("h-10 rounded-xl border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring", className)}
    {...rest}
  >
    {children}
  </select>
);

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      <h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const Empty = ({ text, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-dashed p-8 text-center text-sm text-muted-foreground">{text}</div>
);
